import React, { useState } from "react";
import cx from "classnames";
import styles from "./dropdownMenu.module.scss";
import { ImageModel, LinkModel } from "../../types/interfaces";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

type IDropdownMenuProps = {
  label?: string;
  selected?: boolean;
  icon?: ImageModel;
  iconClassName?: string;
  iconComponent?: any;
  className?: string;
  menuOptions: LinkModel[];
};

const DropdownMenu: React.FC<IDropdownMenuProps> = (props) => {
  const { iconComponent, className, menuOptions } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [active, setIsActive] = useState(false);

  return (
    <>
      <button
        className={styles.dropdownButton + " " + className}
        onClick={() => setIsActive(!active)}>
        {iconComponent && <props.iconComponent />}
      </button>
      {active ? (
        <div className={styles.menuOptions}>
          <ul className={styles.menuOptions__list}>
            {menuOptions?.map((e, index) => {
              return e.outLink ? (
                <a
                  key={e?.id ? e?.id : "dropdown__option" + index}
                  className={styles.menuOptions__item}
                  href={e.outLink}
                  target="_blank">
                  <span className={`${cx("buttonSM neutral1000")}`}>
                    {t(e.label)}
                  </span>
                </a>
              ) : (
                <li
                  className={styles.menuOptions__item}
                  key={e?.id ? e?.id : "dropdown__option" + index}
                  onClick={() => {
                    if (e.action) {
                      dispatch(e.action(e.id));
                    }
                  }}>
                  <span className={`${cx("buttonSM neutral1000")}`}>
                    {t(e.label)}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}
      {active ? (
        <div
          className={styles.backgroundLayer}
          onClick={() => setIsActive(!active)}></div>
      ) : null}
    </>
  );
};

export default DropdownMenu;
